/** Outbound links and addresses the marketing site renders. The app's own
 *  navigation config (workspace/project routes, breadcrumbs, page titles)
 *  stays in the app repo -- this site links *into* the app through
 *  `appUrl()` in `@/lib/app-links`, and never models its routes. */

export const appDomain = "artless.dev"
export const siteOrigin = `https://${appDomain}`

export const contactEmailUser = "hello"
export const contactEmailDomain = appDomain
export const contactEmail = `${contactEmailUser}@${contactEmailDomain}`

/** Product documentation -- a separate Astro/Starlight deployment
 *  (`binskea/artlessdev-docs`), so this is an absolute URL rather than a route
 *  on this site. Link to the docs root only; individual doc pages move as that
 *  site's sidebar is reorganized. */
export const docsUrl = "https://docs.artless.dev"
